import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './AuthCallback.css';

const AuthCallback = ({ setUser }) => {
  const navigate = useNavigate();
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    // After Google login, the backend redirects here with token and user_id in the URL
    // Example URL: /consent?token=abc123&user_id=uuid  OR  /chat?token=abc123&user_id=uuid
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const userId = params.get("user_id");

    if (!token || !userId) {
      console.error("Missing token or user_id in URL params");
      alert("خطا در ورود با گوگل. لطفاً دوباره امتحان کنید.");
      navigate("/");
      return;
    }

    // Save credentials to localStorage
    localStorage.setItem("token", token);
    localStorage.setItem("user", userId);
    setUser(userId);

    // The backend already decided if user needs /consent or /chat
    // It encoded that in the redirect path, so we just use window.location.pathname
    const path = window.location.pathname; // will be "/consent" or "/chat"
    navigate(path, { replace: true });

  }, [navigate, setUser]);

  return (
    <div className="auth-loading-wrapper">
      <div className="spinner" />
      <p className="auth-loading-text">در حال ورود با حساب گوگل...</p>
    </div>
  );
};

export default AuthCallback;
